export class StockIdsReq{
    stockIds : []

    constructor(stockIds:[]){
        this.stockIds = stockIds
    }
}